import React, { FC, memo } from "react";
import { createUseStyles } from "react-jss";

import DestinationsMobile from "Assets/images/destinationsMobile.svg";
import { areEqualShallow } from "Utils/areEqual";
import styles from "./styles";

interface Props {
  onClick: (e: any) => void;
  className?: string;
}
const DestinationsMobileIcon: FC<Props> = memo(
  ({ onClick, className }: Props) => {
    const classes = createUseStyles(styles)();
    const click = (e: any) => {
      e.preventDefault();
      if (onClick) onClick(e);
    };
    return (
      <DestinationsMobile
        id="destinationMobileIcon"
        className={`${classes.pointer} ${className || ""}`}
        onClick={click}
      />
    );
  },
  areEqualShallow
);
DestinationsMobileIcon.defaultProps = {
  className: undefined,
};
export default DestinationsMobileIcon;
try {
    // @ts-ignore
    DestinationsMobile.displayName = "DestinationsMobile";
    // @ts-ignore
    DestinationsMobile.__docgenInfo = { "description": "", "displayName": "DestinationsMobile", "props": { "onClick": { "defaultValue": null, "description": "", "name": "onClick", "required": true, "type": { "name": "(e: any) => void" } }, "className": { "defaultValue": { value: "undefined" }, "description": "", "name": "className", "required": false, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Icons/DestinationsMobile/DestinationsMobile.tsx#DestinationsMobile"] = { docgenInfo: DestinationsMobile.__docgenInfo, name: "DestinationsMobile", path: "src/shared/components/Icons/DestinationsMobile/DestinationsMobile.tsx#DestinationsMobile" };
}
catch (__react_docgen_typescript_loader_error) { }